import { DownloadAppButton } from "@/components/DownloadAppButton/DownloadAppButton";
import { Text, VStack } from "@leplein/ui";
import { useTranslation } from "react-i18next";

export const NotFoundPage = () => {
	const { t } = useTranslation("common");

	return (
		<VStack className="justify-between flex-1 px-8 py-10 bg-[url(/assets/img/wave-black.svg)] bg-center bg-no-repeat bg-contain">
			<VStack space="xl" className="items-center justify-center flex-1">
				<Text size="sm" className="text-center text-neutral-0">
					{t("error.headline")}
				</Text>

				<VStack space="sm" className="items-center">
					<Text variant="brand" size="4xl" className="text-center text-primary-600">
						{t("error.heading")}
					</Text>
					<Text size="md" semiBold className="text-center text-neutral-0">
						{t("error.subheading")}
					</Text>
				</VStack>

				<img alt={t("error.heading")} src="/assets/img/phone-location.svg" width={125} />
			</VStack>

			<VStack className="w-full pt-4">
				<DownloadAppButton />
			</VStack>
		</VStack>
	);
};
